export default __webpack_public_path__ + "static/media/oktoberfest-hero.c46023be.svg";